import { render, staticRenderFns } from "./AsignarList.vue?vue&type=template&id=98e013a2&"
import script from "./AsignarList.vue?vue&type=script&lang=js&"
export * from "./AsignarList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports